import { axiosInstance } from "./";

const login = async (payload) => await axiosInstance.post("/sessions", payload);

const logout = async () => await axiosInstance.delete("/sessions");

const accessToken = async () =>
  await axiosInstance.get("/sessions/refresh_access_token");

const resetPassword = async (payload) =>
  await axiosInstance.post("/admins/reset_password", payload);

export { login, logout, accessToken, resetPassword };
